var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-stats"},_vm._l((_vm.statsList),function(item,index){return _c('div',{key:index,staticClass:"stat-item"},[_c('div',{staticClass:"stat-title"},[_vm._v(_vm._s(item.title))]),_c('div',{staticClass:"stat-number"},[_vm._v(_vm._s(item.number))]),_c('div',{staticClass:"stat-desc"},[_vm._v(_vm._s(item.desc))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }